import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// AmplifyをVueで使用できるように追記
import Amplify, * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";
import awsmobile from "./aws-exports";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/ja'; // ElementUIでの言語設定、datePickerとかで適用される

Amplify.configure(awsmobile);

Amplify.configure({
  Auth: {
    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId: 'ap-northeast-1:bc2c088c-1bf6-468e-a80d-03330614dba4',
    
    // REQUIRED - Amazon Cognito Region
    region: 'ap-northeast-1',

    // OPTIONAL - Amazon Cognito Federated Identity Pool Region 
    // Required only if it's different from Amazon Cognito Region
    identityPoolRegion: 'ap-northeast-1',

    // OPTIONAL - Amazon Cognito User Pool ID
    //userPoolId: 'XX-XXXX-X_abcd1234',

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    //userPoolWebClientId: 'a1b2c3d4e5f6g7h8i9j0k1l2m3',

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: false
  },
  Storage: {
      AWSS3: {
        //REQUIRED -  Amazon S3 bucket
        bucket: 'dnp05c-poc-s3-formkit-upload-data',
        //OPTIONAL -  Amazon service region
        region: 'ap-northeast-1',

        identityPoolId: 'ap-northeast-1:bc2c088c-1bf6-468e-a80d-03330614dba4',
    
      }
  }
});


Vue.use(AmplifyPlugin, AmplifyModules);
Vue.use(ElementUI, {locale});

////

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
